export default {
  // Acciones sobre un sprint (listado/tarjeta)
  labels: {
    sprints: 'Sprints',
    preview: 'Previsualizar',
    edit: 'Editar sprint',
    edit_config: 'Configuración del sprint',
    delete: 'Eliminar sprint',
    desired_points: 'Puntos a cumplir'
  },

  // Formulario de creacion de un sprint
  create: {
    name: 'Nombre del Sprint',
    description: 'Descripción del Sprint',
    role: 'Rol Asignado',
    franchise: 'Unidad de Negocio Asignada'
  }
}
